
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/business-startup-support/page/[id]",
      function () {
        return require("private-next-pages/cases/business-startup-support/page/[id].tsx");
      }
    ]);
  